<template>
</template>

<script>
import { isLoggedIn, login, logout } from '../utils/auth'
import { getUser } from '../utils/battles-api'

export default {
  data() {
    return {}
  },
  methods: {
    handleLogin() {
      login()
    },
    isLoggedIn() {
      return isLoggedIn()
    }
  },
  mounted() {
    // if client thinks i'm not logged in
    if (!this.isLoggedIn()){
      login()
    } else {
      // There is the change the client things it's logged in,
      // but isn't on server.
      this.$router.push({ path: 'home' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue